import { useUserData } from '../../../hooks'
import { isManagerUser } from '../../../utils/user'
import { FormModal } from '../../Form'
import { MODAL_HEADER_VARIANT } from '../../Modal'

import {
  getAccessInitialValues,
  getDocumentEditAccessValidationSchema,
} from './DocumentEditAccessActionModal.utils'
import { DocumentEditAccessActionModalFields } from './DocumentEditAccessActionModalFields'

function DocumentEditAccessActionModal({
  checkNoChanges = true,
  id,
  inheritField,
  initialValues,
  isFolder,
  onClose,
  onSubmit,
}) {
  const user = useUserData()

  const isManagerUserAcc = isManagerUser(user)

  const preparedInitialValues = getAccessInitialValues({
    initialValues,
    isFolder,
    isManager: isManagerUserAcc,
  })

  const validationSchema = getDocumentEditAccessValidationSchema({
    checkNoChanges,
    initialValues: preparedInitialValues,
  })

  function handleSubmit({ values }) {
    onSubmit(values, id)
  }

  return (
    <FormModal
      Fields={DocumentEditAccessActionModalFields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
      }}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{
        inheritField: inheritField || isFolder,
      }}
      formTitle='Modal.DocumentEditAccessActionKey'
      initialValues={preparedInitialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default DocumentEditAccessActionModal
